<template>
  <div class="ellipsis-menu py-3">
    <vs-dropdown>
      <a class="a-icon px-4" href="#">
        <i class="fas fa-ellipsis-v" style="font-size: 1.5rem"></i>
      </a>

      <vs-dropdown-menu :vs-trigger-click="true" style="min-width: 400px">
        <vs-dropdown-item
          v-if="!isDescriptionOn"
          @click="handleDescriptionOn(true)"
          class="ellipsis-text"
        >
          <span class="menu-icon"></span>
          <span>Show Description</span></vs-dropdown-item
        >
        <vs-dropdown-item
          v-else
          @click="handleDescriptionOn(false)"
          class="ellipsis-text"
        >
          <i class="fas fa-check menu-icon mr-2"></i>
          <span>Show Description</span></vs-dropdown-item
        >
        <vs-dropdown-item
          v-if="!isConditionToggle && isConditionEnabled"
          @click="handleConditionToggle(true)"
          class="ellipsis-text"
          >Show hidden questions based on answer</vs-dropdown-item
        >
        <vs-dropdown-item
          v-else-if="isConditionEnabled"
          @click="handleConditionToggle(false)"
          class="ellipsis-text"
          ><i class="fas fa-check menu-icon mr-2"></i> Show hidden questions
          based on answer</vs-dropdown-item
        >
        <vs-dropdown-item
          @click="
            () => {
              onFilterClick ? onFilterClick() : '';
            }
          "
          class="ellipsis-text"
        >
          <i v-if="isFilterEnabled" class="fas fa-check menu-icon mr-2"></i>
          Filter this Question
        </vs-dropdown-item>
        <vs-dropdown-item
          @click="
            () => {
              onValidationClick ? onValidationClick() : '';
            }
          "
          class="ellipsis-text"
          v-if="isValidationOn"
        >
          <i v-if="isValidateEnabled" class="fas fa-check menu-icon mr-2"></i>
          Answer Validation
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    onDelete: false,
    onDescriptionToggle: {
      type: Function,
    },
    onConditionToggle: {
      type: Function,
    },
    onFilterClick: {
      type: Function,
    },
    onValidationClick: {
      type: Function,
    },
    isDeleteClicked: {
      type: Boolean,
    },
    isDeleteConfirmed: {
      type: Boolean,
    },
    isDescriptionOn: {
      type: Boolean,
    },
    isValidationOn: {
      type: Boolean,
    },
    isConditionToggle: {
      type: Boolean,
    },
    isDefaultToggle: {
      type: Boolean,
    },
    isConditionEnabled: {
      type: Boolean,
    },
    isFilterEnabled: {
      type: Boolean,
    },
    isValidateEnabled: {
      type: Boolean,
    },
  },
  // data() {
  //   return {
  //     isDeleteClicked: false,
  //     isDeleteConfirmed: false,
  //     isDescriptionOn: false,
  //     isConditionToggle: false,
  //     isDefaultToggle: false,
  //   }
  // },
  methods: {
    onDeleteClicked() {
      this.isDeleteClicked = true;
      this.isDeleteConfirmed = true;
    },
    handleDelete() {
      // Add your delete logic here
      if (this.onDelete) {
        this.onDelete();
      }
    },
    // handleDropdownClose(bvEvent) {
    //   if (this.isDeleteClicked) {
    //     this.isDeleteClicked = false;
    //     bvEvent.preventDefault()
    //   } else {
    //     this.isDeleteConfirmed = false;
    //   }
    // },
    handleDescriptionOn(enalbled) {
      this.$emit("update:isDescriptionOn", enalbled);
    },
    handleConditionToggle(enabled) {
      this.$emit("update:isConditionToggle", enabled);
    },
  },
};
</script>

<style scoped>
/* Add your custom styles for the ellipsis menu */
.ellipsis-menu {
  display: flex;
  align-items: center;
}
.ellipsis-menu i {
  color: rgb(98,98,98);
}

.ellipsis-icon {
  cursor: pointer;
}
.ellipsis-text {
  font-size: 1.2rem;
}

.menu-icon {
  width: 15px;
}
</style>

<style>
.btn-group button {
  border-bottom-right-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}
.dropdown-toggle-no-caret::after {
  display: none !important;
}
</style>
